<template>
    <Page withNavbar withNavigation>
        <main>
            <SectionTitle
                :title="config.BRIEF_STEPS_TITLE"
                :description="config.BRIEF_STEPS_DESCRIPTION"
            />
            <section class="steps">
                <div v-for="(step, index) in steps" :key="index" class="step">
                    <div class="image">
                        <component :is="step.image" :color="config.COLOR_PRIMARY"/>
                    </div>
                    <div class="text">
                        <h4>{{ step.title }}</h4>
                        <p>{{ step.description }}</p>
                    </div>
                </div>
            </section>
            <BriefLegal v-model="legal"/>
            <SectionNavigation v-show="legal" :to="{ name: next }"/>
        </main>
    </Page>
</template>
<script>
import { SolutionConsumer } from '@skeepers/platform-framework/mixins';
import { Page, SectionNavigation } from '@skeepers/platform-framework/components/mobile';
import { SectionTitle } from '@skeepers/platform-framework/components/shared';
import {
    IconBrief1,
    IconBrief2,
    IconBrief3,
    IconBrief4,
} from '@skeepers/platform-framework/components/svg';
import { BriefLegal } from '@/components/shared';

export default {
    name: 'BriefSteps',
    components: {
        BriefLegal, Page, SectionTitle, SectionNavigation,
    },
    mixins: [SolutionConsumer],
    props: {
        next: {
            type: String,
            default: 'brief.reward',
        },
    },
    data () {
        return {
            legal: false,
        };
    },
    computed: {
        steps () {
            return [
                {
                    title: this.config.BRIEF_STEPS_TYPEFORM_TITLE,
                    description: this.config.BRIEF_STEPS_TYPEFORM,
                    image: IconBrief1,
                }, {
                    title: this.config.BRIEF_STEPS_UPLOAD_TITLE,
                    description: this.config.BRIEF_STEPS_UPLOAD,
                    image: IconBrief2,
                }, {
                    title: this.config.BRIEF_STEPS_CONTACT_TITLE,
                    description: this.config.BRIEF_STEPS_CONTACT,
                    image: IconBrief3,
                }, {
                    title: this.config.BRIEF_STEPS_AMBASSADOR_TITLE,
                    description: this.config.BRIEF_STEPS_AMBASSADOR,
                    image: IconBrief4,
                },
            ];
        },
    },
};
</script>
<style lang="scss" scoped>
@import '~@skeepers/platform-framework/assets/scss/mixins';
@import '~@skeepers/platform-framework/assets/scss/colors';

main {
    @include container(40px 20px);
    flex-grow: 1;

    > section {
        &.title {
            text-align: center;
        }

        &.steps {
            > .step {
                @include card(20px);
                display: flex;
                align-items: center;

                &:not(:last-of-type):not(:only-of-type) {
                    margin-bottom: 10px;
                }

                > .image {
                    margin-right: 20px;

                    > svg {
                        @include square(40px);
                        display: block;
                    }
                }

                > .text {
                    flex: 1;

                    > h4 {
                        font-weight: 700;
                    }

                    > p {
                        line-height: 1;
                    }
                }
            }
        }

        &.navigation {
            text-align: right;
            font-weight: 600;

            > a {
                @include a-reset();
            }
        }
    }
}
</style>
